import script from "./YamlTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./YamlTab.vue?vue&type=script&setup=true&lang=ts"

import "./YamlTab.vue?vue&type=style&index=0&id=49cdc8f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49cdc8f2"]])

export default __exports__